import { JOB_SERVICES_ENDPOINT } from "../../../../consts";
import { useCRUD } from "../../../../api/crud";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import HomeRepairServiceOutlinedIcon from "@mui/icons-material/HomeRepairServiceOutlined";
import { useHasPermission } from "../../../../contexts/auth";
import { useBreadcrumbs } from "../../../../components/ui/breadcrumps/breadcrumbsContext";
import { DetailPage, DetailRow } from "../../../../components/ui/detailView";
import { formatNumber } from "../../../../utils";
import { CatalogItemDetail } from "../../catalogItemDetail/catalogItemDetail.component";

export const JobServiceCatalogBasicInfo = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const { get } = useCRUD(JOB_SERVICES_ENDPOINT);
  const { setOverride } = useBreadcrumbs();
  const [jobService, setJobService] = useState<any | null>(null);
  const canViewJobServices = useHasPermission("service.view_jobservice");

  useEffect(() => {
    const fetchJobService = async () => {
      if (id) {
        const response = await get(id);
        if (response.data) {
          setJobService(response.data);
          setOverride(`/service/services-catalog/${id}`, response.data.title || id);
        }
      }
    };

    const handleJobServiceUpdated = () => {
      fetchJobService();
    };

    window.addEventListener("jobServiceCatalogUpdated", handleJobServiceUpdated);
    fetchJobService();
    return () => {
      window.removeEventListener("jobServiceCatalogUpdated", handleJobServiceUpdated);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (!canViewJobServices) {
    return null;
  }

  if (!jobService) return <DetailPage loading />;

  return (
    <CatalogItemDetail
      item={jobService}
      icon={<HomeRepairServiceOutlinedIcon />}
      extraRows={
        <>
          <DetailRow
            label={t("Price (net)")}
            value={
              jobService.price != null && jobService.price !== ""
                ? `${formatNumber(jobService.price)} zł`
                : null
            }
          />
          <DetailRow
            label={t("Internal cost (net)")}
            value={
              jobService.cost != null && jobService.cost !== ""
                ? `${formatNumber(jobService.cost)} zł`
                : t("As the price")
            }
          />
          <DetailRow label={t("Unit")} value={jobService.unit} />
        </>
      }
    />
  );
};
